import { render } from "./Servicios.vue?vue&type=template&id=3d596670&scoped=true"
import script from "./Servicios.vue?vue&type=script&lang=js"
export * from "./Servicios.vue?vue&type=script&lang=js"

import "./Servicios.vue?vue&type=style&index=0&id=3d596670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d596670"]])

export default __exports__